module.exports = __webpack_public_path__ + "img/andong_thumbnail.bb761aa8.jpg";